import { pages } from '@microsoft/teams-js';

interface ReferenceProps {
    documents: Array<{
        name: string;
        data: string;
        url: string | undefined;
    }>;
}

export function PoiReferences(props: ReferenceProps) {


    const processedReferences = props.documents.map(element => {
        const newElement = { ...element };
        if (newElement.url) {
            const url = new URL(newElement.url);
            const name = url.searchParams.get('name') || '';
            const guidMatch = newElement.url.match(/poi:\/\/([^/]+)/);
            const guid = guidMatch ? guidMatch[1] : '';

            newElement.name = name;
            newElement.url = guid;
        }
        return newElement;
    });

    const handleNavigateToFactoryTab = async (item: string) => {
        try {

            await pages.currentApp.navigateTo({
                pageId: "index3",
                subPageId: item
            });
        } catch (error) {
            console.error('Navigation to POI tab failed:', error);
        }
    };

    return (
        <div className="document-references">
            <h2>Referenced report</h2>
            <ul className="list-disc pl-5">
                {processedReferences
                    .filter((item, index, self) =>
                        item.url && self.findIndex(t => t.url === item.url) === index
                    )
                    .map((item, index) => (
                        <li key={index}>
                            <button
                                onClick={() => {
                                    if (item.url) {
                                        handleNavigateToFactoryTab(item.url);
                                    }
                                }}
                                className="text-chat-link underline hover:text-chat-link/80 border-none cursor-pointer p-0"
                            >
                                {item.name ? item.name : ''}
                            </button>
                        </li>
                    ))}
            </ul>
            {props.documents.length === 0 && <p>No document references available.</p>}
        </div>
    );
}